import React from "react";
import PropTypes from "prop-types";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import { NavLink } from "react-router-dom";

import { useUsers } from "hooks";
import { appRoutes } from "routes";
import logoVertical from "assets/images/common/logo-vertical.png";
import Navigation from "layouts/UserLayout/components/Header/components/Navigation";
import UserPresenter from "presenters/UserPresenter";
import ResponsiveImage from "components/ResponsiveImage";
import { headerSelector } from "tests/selectors/index.js";

import useStyles from "./useStyles";

const DesktopHeader = (props) => {
  const classes = useStyles();
  const { onDrawerOpen } = props;
  const { currentUser } = useUsers();

  return (
    <div className={classes.root}>
      <NavLink id="header-logo-desktop" to={appRoutes.rootPath()}>
        <ResponsiveImage
          src={logoVertical}
          alt="JibJab"
          className={classes.logo}
          height={68}
          width={75}
          widthMobile={75}
        />
      </NavLink>

      <div className={classes.nav}>
        <Navigation {...props} />
      </div>

      <div className={classes.actions}>
        <div className={classes.action}>
          <NavLink id="header-search-desktop" color="inherit" aria-label="search" to={appRoutes.searchPath()}>
            <SearchIcon className={classes.searchIcon} fontSize="large" />
          </NavLink>
        </div>
        {!UserPresenter.isRegistered(currentUser) && (
          <div className={classes.action}>
            <NavLink
              id="header-sign-up-desktop"
              className={classes.buttonLink}
              to={appRoutes.signUpPath()}
              data-testid={headerSelector.buttons.signup}
            >
              Sign Up
            </NavLink>
          </div>
        )}
        {UserPresenter.isRegistered(currentUser) && !UserPresenter.isPaid(currentUser) && (
          <div className={classes.action}>
            <NavLink
              id="header-upgrade-desktop"
              className={classes.buttonLink}
              to={appRoutes.paymentPath()}
              data-testid={headerSelector.buttons.upgrade}
            >
              <span>Upgrade</span>
            </NavLink>
          </div>
        )}
        <div className={classes.action}>
          <IconButton
            id="header-hamburger-desktop"
            className={classes.menuIconButton}
            disableRipple={false}
            disableFocusRipple={false}
            color="primary"
            aria-label="menu"
            onClick={onDrawerOpen}
            data-testid={headerSelector.buttons.hamburguer}
            size="large"
          >
            <MenuIcon className={classes.menuIcon} fontSize="large" />
          </IconButton>
        </div>
      </div>
    </div>
  );
};

DesktopHeader.propTypes = {
  onDrawerOpen: PropTypes.func.isRequired,
};

export default DesktopHeader;
